import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import DatePicker from '../components/DatePicker/DatePicker'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'
import Row from '../components/Row/Row'
import TableHorizontal, { TableHorizontalData, TableHorizontalHeader } from '../components/TableHorizontal'

interface BillOfLadingGenerateFormProps {
  loadStartAt: string
  departureAt: string
  trailerNumber: string
  sealNumber: string
  driverCheckInAt: string
  supervisorName: string
  driverName: string
  carrier: string
  note: string
  items: TableHorizontalData<ItemData>[]
  onDateChange: (name: string, date: string) => void
  onInputChange: (name: string, value: string) => void
  onGenerateClick: () => void
}

interface BillOfLadingGenerateFormState {}

export default class BillOfLadingGenerateForm
  extends Component<BillOfLadingGenerateFormProps, BillOfLadingGenerateFormState> {
  tableHeaders: TableHorizontalHeader[] = [
    { heading: i18n('Item code'), path: 'code' },
    { heading: i18n('Description'), path: 'description' },
    { heading: i18n('Units'), path: 'shipOrderItem.shippedQuantity' },
    { heading: i18n('Pallets'), path: 'shipOrderItem.shippedPalletsCount' },
    { heading: i18n('Weight'), path: 'shipOrderItem.shippedWeight' }
  ]

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Generate Bill of Lading")}
          doc='bills-of-lading-generate-and-print-bill-of-lading' />
        <Row column={3}>
          <DatePicker
            name="loadStartAt"
            value={this.props.loadStartAt}
            label={i18n("Load start time")}
            time={true}
            onChange={this.props.onDateChange} />
          <DatePicker
            name="departureAt"
            value={this.props.departureAt}
            label={i18n("Departure time")}
            time={true}
            onChange={this.props.onDateChange} />
          <InputText
            name="trailerNumber"
            value={this.props.trailerNumber}
            label={i18n("Trailer number")}
            onChange={this.props.onInputChange} />
          <InputText
            name="sealNumber"
            value={this.props.sealNumber}
            label={i18n("Seal number")}
            onChange={this.props.onInputChange} />
          <DatePicker
            name="driverCheckInAt"
            value={this.props.driverCheckInAt}
            label={i18n("Driver checkin")}
            time={true}
            onChange={this.props.onDateChange} />
          <InputText
            name="supervisorName"
            value={this.props.supervisorName}
            label={i18n("Ship supervisor name")}
            onChange={this.props.onInputChange} />
          <InputText
            name="driverName"
            value={this.props.driverName}
            label={i18n("Driver name")}
            onChange={this.props.onInputChange} />
          <InputText
            name="carrier"
            value={this.props.carrier}
            label={i18n("Carrier")}
            onChange={this.props.onInputChange} />
          <InputText
            name="note"
            value={this.props.note}
            label={i18n("Note")}
            onChange={this.props.onInputChange} />
        </Row>
        <TableHorizontal
          headers={this.tableHeaders}
          data={this.props.items} />
        <CardButton
          proceedText={i18n("Generate")}
          cancelText={i18n("Cancel")}
          onProceedClick={this.props.onGenerateClick} />
      </Card>
    )
  }
}
